import { gql } from "@apollo/client";

export const BATCH_HANDLE_DRIVER_MIS_SCAN_CONFIRM_RECEIVE = gql`
    mutation BatchHandleDriverMisScanConfirmReceive($parcels: [DriverMisScanParcelInput!]!) {
        batchHandleDriverMisScanConfirmReceive(parcels: $parcels)
    }
`;
